import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ButtonProgress from '../../../commons/ButtonProgress';
import { useStyles } from '../checkoutDrawer.styles';

function ThreeDSecureView ({ actionURL }) {
    const classes = useStyles();
    const [isAuthenticating, setIsAuthenticating] = useState(false);

    function handleAuthenticate () {
        window.open(actionURL, '_blank');
        setIsAuthenticating(true);
    }

    return (
        <div className={classes.processingContainer}>
            <p className={classes.processingText}>Your card requires 3D secure authentication.</p>
            <p className={classes.processingText}>
                If your bank authentication pop-up did not show, please turn off the pop-up blocker and try again.
            </p>
            <ButtonProgress
                disabled={!actionURL}
                showProgress={isAuthenticating}
                label="Authenticate 3DS"
                onClick={handleAuthenticate}
            />
        </div>
    );
}

ThreeDSecureView.propTypes = {
    actionURL: PropTypes.string,
};

ThreeDSecureView.defaultProps = {
    actionURL: '',
};

export default ThreeDSecureView;
